import React, { Component } from 'react'
import ReactDom from 'react-dom'
import MainAppBar from 'components/appbar'
import TimeSheetPage from 'timesheetPage'
import AdminPage from 'adminPage'
import WeekReportPage from 'weekReportPage'
import AuthPage from 'authPage'
import md5 from 'blueimp-md5'
import co from 'co'
import { aUtils, aProjects } from 'utils/aUtils'
import misc from 'utils/misc'

class App extends Component {

  constructor (props, context) {
    super(props, context)
    this.onLoginSubmit = this.onLoginSubmit.bind(this)
    this.onLogout = this.onLogout.bind(this)
  }

  state = {
    route: window.location.hash.substr(1),
    me: null,
    isProjectLeader: false,
    loginFailed: false,
  };

  componentWillMount () {
    const _this = this
    co(function *() {
      const me = yield aUtils.me()
      const projects = yield aProjects.find()
      let isProjectLeader = false
      projects.forEach(project => {
        if (project.usersId === me._id && project.stage === '1') {
          isProjectLeader = true
        }
      })
      _this.setState({ me, isProjectLeader })
    })
    .catch(e => {
      this.setState({ isProjectLeader: false })
      console.log(`in error: componentWillMount ${e}`)
    })
  }

  componentDidMount () {
    window.addEventListener('hashchange', () => {
      this.setState({
        route: window.location.hash.substr(1),
      })
    })
  }

  onLoginSubmit (username, password) {
    const _this = this
    co(function *() {
      yield aUtils.login(username, md5(password))
      const me = yield aUtils.me()
      const projects = yield aProjects.find()
      let isProjectLeader = false
      projects.forEach(project => {
        if (project.usersId === me._id && project.stage === '1') {
          isProjectLeader = true
        }
      })
      _this.setState({ me, isProjectLeader })
      window.location.hash = '/timesheet'
    })
    .catch((e) => {
      this.setState({ loginFailed: true })
      console.log(`loginFailed: ${e}`)
    })
  }

  onLogout () {
    aUtils.logout()
    .then(() => {
      this.setState({ me: null, loginFailed: false })
      window.location.hash = ''
    }).catch(misc.onError)
  }

  render () {
    let child = null
    const { me, route, loginFailed, isProjectLeader } = this.state
    if (me === null) {
      child = <AuthPage me={me} onSubmit={this.onLoginSubmit} showError={loginFailed} />
    } else {
      switch (route) {
        case '/admin':
          child = (me.role === 'admin') ? <AdminPage /> : null
          break

        case '/timesheet':
          child = <TimeSheetPage me={me} />
          break

        case '/project':
          child = <WeekReportPage me={me} />
          break

        case '/logout':
          this.onLogout()
          break

        default:
          child = <TimeSheetPage me={me} />
      }
    }

    // console.log(isProjectLeader)

    return (
      <div>
        <MainAppBar user={me} isProjectLeader={isProjectLeader} />
        {child}
      </div>
    )
  }
}

function mountApp () {
  // Needed for React Developer Tools
  window.React = React

  ReactDom.render(<App />, document.getElementById('app'))
}

mountApp()



// WEBPACK FOOTER //
// ./src/app/app.jsx